import { ARTICLE, AUTHENTICATED } from 'lib/myNewsConstants';
import { getMParticleId } from 'lib/getMParticleId';
import { shouldCallSaveHistory } from 'lib/historyFlags';
import { useEffect } from 'react';

/**
 * Custom hook to save the article history when authenticated.
 *
 * @param {object} params - The parameters for the hook.
 * @param {string} params.authenticationState - The current authentication state.
 * @param {string} params.savedContentId - The ID of the saved content.
 * @param {Article} params.article - The article object.
 * @param {Function} params.saveHistory - The function to save the history.
 * @param {string} params.articleId - The ID of the article.
 * @param {Record<string, boolean>} params.featureFlags - the launch darkly feature flags
 */
export function useSaveArticleHistory({
  authenticationState,
  savedContentId,
  article,
  saveHistory,
  articleId,
  featureFlags,
}) {
  useEffect(() => {
    const mParticleId = getMParticleId();
    const callSaveHistory = shouldCallSaveHistory({ featureFlags });
    if (callSaveHistory && authenticationState === AUTHENTICATED && (savedContentId !== article?.id) && mParticleId) {
      saveHistory({ contentId: articleId, contentType: ARTICLE });
    }
  }, [authenticationState, article?.id, saveHistory, savedContentId, featureFlags?.['nbc-news-bedrock'], featureFlags?.['account-history']]);
}
